const coachSelector = document.querySelector(".coach-selector-background");
const close = document.getElementById("coach-selector-close");
const open = document.getElementById("coach-selector-open");


const toggleCoachSelector = function () {
  coachSelector.classList.toggle("hidden");
};

close.addEventListener("click", function(e) {
  toggleCoachSelector();
})
open.addEventListener("click", function(e) {
  toggleCoachSelector();
})
